class Confirmation {
    constructor() {
        this.id = 0;
        this.shown = 0;

    }
    show(id, service) {
        console.log(this.shown);
        this.id = id;
        this.service = service;
        this.loadDialog();
    }

    init(dialog) {
        dialog.on('hidden.bs.modal', (e) => {
            this.shown = 0;
            dialog.remove();
        });
        dialog.on('shown.bs.modal', (ev) => {
            $(function () {
                this.initUploader();
            });
        });


    }

    save() {
        var cState = $("select[name=newstate] option:selected").val();
        axios.post('/'+this.service+'service/confirmation/save', {id: this.id, cState: cState, text: $("input[name=comment]").val()})
            .then(response => {
                $("#ConfirmationModal .modal-body").html(response.data.html);
                this.initUploader();
                var btn = $(".reporting-table tr[data-id="+this.id+"] .btn-confirmation");
                var span = btn.find("span");
                btn.removeClass("btn-primary").removeClass("btn-danger").removeClass("btn-success").removeClass("btn-warning").removeClass("btn-dark").removeClass("btn-info");
                span.removeClass("oi-check").removeClass("oi-x").removeClass("oi-pin").removeClass("oi-timer").removeClass("oi-question-mark").removeClass("oi-wrench");
                if(cState == 'confirmed') {
                    btn.addClass('btn-success');
                    span.addClass('oi-check');
                }
                else if (cState =='processing') {
                    btn.addClass('btn-info');
                    span.addClass('oi-wrench');
                } else if (cState =='declined') {
                    btn.addClass('btn-dark');
                    span.addClass('oi-x');
                } else if (cState == 'waiting') {
                    btn.addClass('btn-warning')
                    span.addClass('oi-timer');
                } else if (cState == 'question') {
                    btn.addClass('btn-danger')
                    span.addClass('oi-question-mark');
                }
            })
    }

    loadDialog() {
        if(this.shown > 0) {
            return;
        }
        this.shown = 1;
        axios.get('/'+this.service+'service/confirmation/'+this.id+'/edit').then(response => {
            if(response.data.html) {
                let dialog = $(response.data.html);
                dialog.modal("show");

                this.init(dialog);
            }
        }).catch(error => {
                console.log(error);
                swal({
                    type: 'error',
                    text: 'Konnte Bestätigungsdialog nicht laden'
                })

            });
    }

    initUploader() {
        console.log('inituploader');
        $('.uploader').fileupload({
            dataType: 'json',

            self: this,
            submit: function (e, data) {
                $.each(data.files, function (index, file) {
                    var filetype = $(e.target).attr('data-filetype');
                    var validfor = $(e.target).attr('data-validfor');
                    var bookingId = $(e.target).attr('data-bookingId');
                    var historyId = $(e.target).attr('data-historyId');
                    var historyId2 = $(e.target).attr('data-historyId2');
                    data.formData = {
                        filetype: filetype,
                        validfor: validfor,
                        bookingId: bookingId,
                        historyId: historyId,
                        historyId2: historyId2
                    };
                    var ext = this.name.split('.').pop().toLowerCase();
                    if (ext != 'pdf') {
                        swal('Nur PDF Dateien');
                    }

                });
            }
        }).bind('fileuploaddone', function (e, data) {
            console.log(data);

            var validfor = data.formData.validfor;
            var id = data.formData.bookingId + '_' + data.formData.historyId;
            var elem = $("<a class=\"pdfconfirmationlink\" target=\"_blank\" href=\"/getConfirmationPdf/vip/" + id + "\"><img src=\"/img/pdficon.png\"/></a>");
            $(e.target).parent().replaceWith(elem);
        });

    }




}
export default new Confirmation();